import { render, staticRenderFns } from "./fullScreenSliderCard.vue?vue&type=template&id=186e7b36&"
import script from "./fullScreenSliderCard.vue?vue&type=script&lang=js&"
export * from "./fullScreenSliderCard.vue?vue&type=script&lang=js&"
import style0 from "./fullScreenSliderCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports